import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { CheckCircleIcon } from '@heroicons/react/16/solid'
import { Badge } from '../../../../components'
import Image from '../../../../components/Image'
import Button from '../../../../components/tailwind/Button'

export default function StartOptionCard({
  title,
  badge,
  description,
  primaryButtonLabel,
  onClickPrimary,
  onClickSecondary,
  onClickText,
  secondaryButtonLabel,
  textButtonLabel,
  image,
  isLoadingPrimary,
  isLoadingSecondary,
  secondaryButtonIcon,
  completed,
  className
}) {
  const { t } = useTranslation()
  return (
    <div
      className={clsx(
        'flex flex-row justify-between rounded-lg border border-softGrey bg-white px-6 py-8',
        className
      )}
    >
      <div className='flex flex-1 flex-col items-start justify-between'>
        <div className={clsx('flex flex-col', completed && 'opacity-70')}>
          <h4 className='text-base font-semibold text-darkBlack'>
            {title}
            {badge && (
              <Badge
                color={'green'}
                text={t(
                  'discover.start_options_section.cards.assessment.badge'
                )}
                className={'ml-2'}
              />
            )}
          </h4>
          <p className='mt-2 w-full max-w-96 text-sm font-normal text-rockGrey'>
            {description}
          </p>
        </div>

        <div className='mt-8 flex flex-row items-center'>
          {primaryButtonLabel && !completed && (
            <Button.PrimaryXL
              isLoading={isLoadingPrimary}
              text={primaryButtonLabel}
              onClick={onClickPrimary}
            />
          )}
          {completed && (
            <div className='flex flex-row items-center'>
              <span className='text-sm font-medium text-mediumGrey'>
                {t('discover.start_options_section.cards.assessment.done')}
              </span>
              <CheckCircleIcon className='ml-1.5 size-4 text-mediumGrey' />
            </div>
          )}
          {secondaryButtonLabel && (
            <Button.SecondaryXL
              text={isLoadingSecondary ? '' : secondaryButtonLabel}
              onClick={onClickSecondary}
              disabled={isLoadingSecondary}
              icon={isLoadingSecondary ? secondaryButtonIcon : null}
              className={clsx(
                'transition-all duration-300 ease-in-out',
                isLoadingSecondary && 'cursor-not-allowed opacity-70'
              )}
            />
          )}
          {textButtonLabel && (
            <Button.Text
              text={textButtonLabel}
              onClick={onClickText}
              className='ml-4'
            />
          )}
        </div>
      </div>
      <div
        className={clsx(
          'hidden flex-1 md:flex md:items-end md:justify-center',
          completed && 'opacity-70'
        )}
      >
        <Image src={image} height={132} />
      </div>
    </div>
  )
}

StartOptionCard.propTypes = {
  title: PropTypes.string.isRequired,
  badge: PropTypes.bool,
  description: PropTypes.string.isRequired,
  primaryButtonLabel: PropTypes.string,
  secondaryButtonLabel: PropTypes.string,
  className: PropTypes.string,
  textButtonLabel: PropTypes.string,
  image: PropTypes.string.isRequired,
  onClickPrimary: PropTypes.func,
  onClickSecondary: PropTypes.func,
  isLoadingPrimary: PropTypes.bool,
  isLoadingSecondary: PropTypes.bool,
  secondaryButtonIcon: PropTypes.node,
  onClickText: PropTypes.func,
  completed: PropTypes.bool
}
